import { gql } from '@apollo/client'

const FULL_CARD_FRAGMENT = gql`
    fragment FullSpritzCard on CheckbookVirtualCard {
        renderSecret
        externalId
        id
        mask
        balance
        holderDetails {
            firstName
            lastName
            phone
            address {
                zip
                state
                city
                line_1
            }
        }
    }
`

export const SPRITZ_CARD_QUERY = gql`
    query SpritzCard {
        virtualCard {
            ...FullSpritzCard
        }
    }
    ${FULL_CARD_FRAGMENT}
`

gql`
    mutation CreateSpritzCard {
        createVirtualCard {
            ...FullSpritzCard
        }
    }
`
